// extracted by css-extract-rspack-plugin
export default {"root":"hiy2Se","removed":"elQhcj","btn-remove":"g7KGzW","btnRemove":"g7KGzW","overlay-icon":"uHEhAB","overlayIcon":"uHEhAB","selected":"P2WB3y"};